import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Banner } from 'src/app/_model/banner';
import { Concessionaria } from 'src/app/_model/concessionaria';
import { Documento } from 'src/app/_model/documento';
import { BannerService } from 'src/app/_service/banner.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    banners: Banner[] = [];
    concessionarias: Concessionaria[];
    politicaPrivacidade: Documento;

    noticias;
    eventos;
    constructor(private activatedRoute: ActivatedRoute,
        private bannerService: BannerService) { }

    ngOnInit(): void {
        this.concessionarias = this.activatedRoute.snapshot.data["concessionarias"];
        let documentos = this.activatedRoute.snapshot.data["documentos"];
        this.politicaPrivacidade = documentos.find(e => e.codigo == "PoliticaPrivacidade");
        this.noticias = [
            {
                texto: 'Tudo sobre Caminhões',
                descricao: 'Leia mais sobre: Tudo sobre Caminhões',
                link: 'https://mercedes-benz.com.br/institucional/imprensa/releases/caminhoes'
            },
            {
                texto: 'Tudo sobre Ônibus',
                descricao: 'Leia mais sobre: Tudo sobre Ônibus',
                link: 'https://mercedes-benz.com.br/institucional/imprensa/releases/onibus'
            },
            {
                texto: 'Tudo sobre Vans',
                descricao: 'Leia mais sobre: Tudo sobre Vans',
                link: 'https://mercedes-benz.com.br/institucional/imprensa/releases/vans'
            }
        ];

        this.eventos = [
            {
                texto: 'Caminhões',
                descricao: 'Leia mais sobre: Caminhões',
                link: 'https://mercedes-benz.com.br/institucional/mundo-mercedes-benz/eventos-caminhoes'
            },
            {
                texto: 'Ônibus',
                descricao: 'Leia mais sobre: Ônibus',
                link: 'https://mercedes-benz.com.br/institucional/mundo-mercedes-benz/eventos-onibus'
            },
            {
                texto: 'Vans',
                descricao: 'Leia mais sobre: Vans',
                link: 'https://mercedes-benz.com.br/institucional/mundo-mercedes-benz/eventos-vans'
            }
        ];
        this.getBanner();
    }

    getBanner() {
        this.bannerService.get('home').subscribe(
            res => this.getBannerSuccess(res),
            err => this.getBannerError(err)
        )
    }

    getBannerError(err: any) {
        console.log(err);
    }

    getBannerSuccess(res: Banner[]) {
        this.banners = res;
    }
}
